<!--
 * @Descripttion: 视频播放页
 * @version: 
 * @Author: jing
 * @Date: 2020-09-10 20:14:58
 * @LastEditors: jing
 * @LastEditTime: 2020-12-09 22:38:57
-->
<template>
  <div class="baseVideo" v-if="result">
    <div class="title">{{ result.title }}</div>
    <video
      id="guanwangfengmian"
      :poster="result.main_img"
      style="width: 100%;"
      controls="controls"
    >
      <source :src="result.videosrc" type="video/mp4" />
    </video>
    <div class="tel-wrap">
      <img
        class="bottom-btn-img call"
        src="http://yqweb.oss-cn-shanghai.aliyuncs.com/yq-rs-make/vcard3/icon-call.png"
        alt
        @click="clickCall"
      />
    </div>
    <Tabbar12 :seleIndex="0"></Tabbar12>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import util from "@/utils/utils";
import { videoList } from "../config";
const Tabbar12 = () => import("@/components/tabbar12");

export default {
  components: { Tabbar12 },
  props: {},
  data() {
    return {
      result: null,
      cardUserInfo: null
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "userInfo",
      "pageInfo",
      "shareSpreadInfo",
      "isInMiniProgram",
      "receiveSpreadInfo"
    ])
  },
  methods: {
    clickCall() {
      util.makePhoneCall(this.cardUserInfo.ui.mobile);
    },
    setShareInfo() {
      util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
        let saleropenid = this.$route.query.saleropenid;
        if (this.global.isLoc && !saleropenid) {
          saleropenid = this.$openid;
        }
        comreq.getUserInfoAndFansInfo(saleropenid).then(data => {
          this.cardUserInfo = data;
          // console.log("销售信息", JSON.parse(JSON.stringify(data)));
          this.cardUserInfo.ui.name
            ? (document.title = `中海·映山湖-${
                this.cardUserInfo.ui.name
              }的电子名片`)
            : "";
          util.setFoundShareCustomPageName(
            `我是${this.cardUserInfo.ui.name}，欢迎您随时联系`,
            `手机号：${this.cardUserInfo.ui.mobile} ${
              this.cardUserInfo.ui.wechatno
                ? "微信号：" + this.cardUserInfo.ui.wechatno
                : ""
            }`,
            this.pageInfo,
            this.shareSpreadInfo,
            false,
            `&entry=zxslzx&t9id=${this.$route.query.t9id}&t9psn=${
              this.$route.query.t9psn
            }&saleropenid=${saleropenid}&backhome=home&t9id=${
              this.$route.query.t9id
            }&t9psn=${this.$route.query.t9psn}`,
            this.cardUserInfo.ui.headimg,
            "vcard3/home"
          );
        });
      });
    }
  },
  created() {
    let videoId = this.$route.query.videoId;
    let tempArr = [...videoList.gfsf, ...videoList.twsf];
    this.result = tempArr.filter(item => videoId == item.id)[0];
    this.setShareInfo();
  },
  mounted() {}
};
</script>
<style lang="stylus" scoped>
// px 转换 rem
p2r(designpx) {
  $rem = 100px;
  return (designpx / $rem) rem;
}
.title{
  dsisplay :flex ;
  text-align: center;
  padding:p2r(20px) 0;
}
.bottom-btn-img{
  width:p2r(100px);
  height:p2r(100px);
}
.bottom-btn-img.call{
  margin-right:p2r(6px)
}
.tel-wrap{
  display :flex;
  justify-content :center;
  position: absolute;
  bottom: 1.6rem;
  width: 100%;

}
</style>
